import React from 'react';
import { HeroSection } from './HeroSection';
import { PainPointSection } from './PainPointSection';
import { SolutionSection } from './SolutionSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { PurchasePopup } from './PurchasePopup';
export function SalesPage() {
  return <div className="min-h-screen font-body bg-cream selection:bg-gold-400 selection:text-white" data-id="element-210">
      <PurchasePopup data-id="element-211" />
      <main data-id="element-212">
        <HeroSection data-id="element-213" />
        <PainPointSection data-id="element-214" />
        <SolutionSection data-id="element-215" />
        <BeforeAfterSection data-id="element-216" />
        <BonusSection data-id="element-217" />
        <PricingSection data-id="element-218" />
        <TestimonialsSection data-id="element-219" />
        <FAQSection data-id="element-220" />
        <FinalCTA data-id="element-221" />
      </main>
      <footer className="bg-brown-800 text-white/60 py-8 text-center text-sm" data-id="element-222">
        <p data-id="element-223">
          © {new Date().getFullYear()} Freezer Inteligente. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-224">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}